export { default as Doctor } from './Doctor';
export { default as Calendar } from './Calendar';
export { default as Patient } from './Patient';
export { default as Pharmacy } from './Pharmacy';
